export const PRODUCT_CATEGORY_URL_PARAM = 'prodcat';
export const SLUG_PRODUCT_URL_PARAM = 'slug-product';
export const DATE_URL_PARAM = 'date';
export const DAY_OF_WEEK_URL_PARAM = 'dow';
export const ADD_DAYS_URL_PARAM = 'adddays';
export const AGE_URL_PARAM = 'age';
export const CONSUMER_CATEGORY_URL_PARAM = 'conscat';
export const VALIDITY_CATEGORY_URL_PARAM = 'valcat';
export const PARTICIPANTS_URL_PARAM = 'p';
export const STUDENT_URL_PARAM = 'stud';
